import DiagramConst from "~/helpers/workareaDiagram/diagramConst";

// This file must stay in sync with ProcessFlowConst in builder_canvas_steps.rb for tests
// to calculate step locations correctly.
export default class ProcessFlowConst extends DiagramConst {
  static readonly StepHeight: number = 100;
  static readonly StepWidth: number = 460;

  // Start and End blocks
  static readonly StartHeight = 50;
  static readonly StartEndHeight = ProcessFlowConst.StartHeight;
  static readonly EndStepHeight = ProcessFlowConst.StartEndHeight; // Used for Disconnected Step Height
  static readonly EndStepWidth = 187;
  static readonly EndStepBorderWidth = 1;
  static readonly StartEndYOffset = 4;
  static readonly StartEndWidth = 460;
  static readonly LoopStartWidth = 187;
  static readonly LoopEndWidth = ProcessFlowConst.LoopStartWidth;
  static readonly StartEndStrokeWidth = 1;
  static readonly StartEndCornerRadius = 10;
  static readonly StartEndArrowLength = 20;
  static readonly DisconnectedStepYOffset = 150;

  static readonly PlusLineLength = 55;


  static startTotalYOffset() {
    return this.StartEndYOffset
  }
}